
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutyMlpg9B6dkMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/about.vue?macro=true";
import { default as activateDJdGqrLZuhMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/activate.vue?macro=true";
import { default as _91slug_93oPWYc6j1VXMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/blogs/[slug].vue?macro=true";
import { default as indexVOG9ePmwvAMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/blogs/index.vue?macro=true";
import { default as categoryM8sqmPdfg9Meta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/category.vue?macro=true";
import { default as contact1vsFfcG1oVMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/contact.vue?macro=true";
import { default as index5Rg70ZZIVeMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/index.vue?macro=true";
import { default as _91id_934hkiFo33USMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/items/[id].vue?macro=true";
import { default as _91id_93rT0jEMGFCUMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/library/[id].vue?macro=true";
import { default as indexGnss8p7uC9Meta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/library/index.vue?macro=true";
import { default as indexGIV7vAqZ8FMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/login/index.vue?macro=true";
import { default as indexsceEHDig6AMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/accounts/index.vue?macro=true";
import { default as downloadsFVJcbhqW1TMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/downloads.vue?macro=true";
import { default as indexbWfEB0Z5uGMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/index.vue?macro=true";
import { default as _91id_93MVZyOjEQfuMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/playlists/[id].vue?macro=true";
import { default as indexFrEjR5f85fMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/playlists/index.vue?macro=true";
import { default as profileCRKSk4sdFxMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/profile.vue?macro=true";
import { default as supportnl5V2ZsI2zMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/support.vue?macro=true";
import { default as walletOj4rzwi2brMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/wallet.vue?macro=true";
import { default as referralr0xrCQcrzIMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/referral.vue?macro=true";
import { default as searchkv9mvxSV6SMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/search.vue?macro=true";
import { default as subscriptionY3PwQOb8LoMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/subscription.vue?macro=true";
import { default as accountstJPzqdux1RMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/accounts.vue?macro=true";
import { default as categoryafpfrk6ScVMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/category.vue?macro=true";
import { default as indexbmkTbbXLeqMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/index.vue?macro=true";
import { default as _91id_93BP8LgDb1MOMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/items/[id].vue?macro=true";
import { default as logingPcMR02I7hMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/login.vue?macro=true";
import { default as _91id_93oI1Lksmbv3Meta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/playlists/[id].vue?macro=true";
import { default as index8NLfeI7UPzMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/playlists/index.vue?macro=true";
import { default as searchAmb6vfmY1zMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/search.vue?macro=true";
import { default as verifyVGsXaI8yyXMeta } from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/verify.vue?macro=true";
export default [
  {
    name: "درباره سدنا",
    path: "/about",
    meta: aboutyMlpg9B6dkMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/about.vue")
  },
  {
    name: "activate",
    path: "/activate",
    meta: activateDJdGqrLZuhMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/activate.vue")
  },
  {
    name: "وبلاگ",
    path: "/blogs/:slug()",
    meta: _91slug_93oPWYc6j1VXMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/blogs/[slug].vue")
  },
  {
    name: "وبلاگ‌ها",
    path: "/blogs",
    meta: indexVOG9ePmwvAMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/blogs/index.vue")
  },
  {
    name: "دسته بندی",
    path: "/category",
    meta: categoryM8sqmPdfg9Meta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/category.vue")
  },
  {
    name: "تماس با ما",
    path: "/contact",
    meta: contact1vsFfcG1oVMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/contact.vue")
  },
  {
    name: "ویترین",
    path: "/",
    meta: index5Rg70ZZIVeMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/index.vue")
  },
  {
    name: "انیمیشن",
    path: "/items/:id()",
    meta: _91id_934hkiFo33USMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/items/[id].vue")
  },
  {
    name: "کتاب",
    path: "/library/:id()",
    meta: _91id_93rT0jEMGFCUMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/library/[id].vue")
  },
  {
    name: "کتابخانه",
    path: "/library",
    meta: indexGnss8p7uC9Meta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/library/index.vue")
  },
  {
    name: "ورود",
    path: "/login",
    meta: indexGIV7vAqZ8FMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/login/index.vue")
  },
  {
    name: "panel-accounts",
    path: "/panel/accounts",
    meta: indexsceEHDig6AMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/accounts/index.vue")
  },
  {
    name: "دانلودها",
    path: "/panel/downloads",
    meta: downloadsFVJcbhqW1TMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/downloads.vue")
  },
  {
    name: "داشبورد",
    path: "/panel",
    meta: indexbWfEB0Z5uGMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/index.vue")
  },
  {
    name: "لیست‌",
    path: "/panel/playlists/:id()",
    meta: _91id_93MVZyOjEQfuMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/playlists/[id].vue")
  },
  {
    name: "لیست‌های پخش",
    path: "/panel/playlists",
    meta: indexFrEjR5f85fMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/playlists/index.vue")
  },
  {
    name: "اطلاعات کاربری",
    path: "/panel/profile",
    meta: profileCRKSk4sdFxMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/profile.vue")
  },
  {
    name: "پشتیبانی",
    path: "/panel/support",
    meta: supportnl5V2ZsI2zMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/support.vue")
  },
  {
    name: "کیف پول و تراکنش‌ها",
    path: "/panel/wallet",
    meta: walletOj4rzwi2brMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/panel/wallet.vue")
  },
  {
    name: "دعوت از دوستان",
    path: "/referral",
    meta: referralr0xrCQcrzIMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/referral.vue")
  },
  {
    name: "جستجو",
    path: "/search",
    meta: searchkv9mvxSV6SMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/search.vue")
  },
  {
    name: "اشتراک",
    path: "/subscription",
    meta: subscriptionY3PwQOb8LoMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/subscription.vue")
  },
  {
    name: "تغییر اعضا تلویزیون",
    path: "/tv/accounts",
    meta: accountstJPzqdux1RMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/accounts.vue")
  },
  {
    name: "تلویزیون دسته بندی",
    path: "/tv/category",
    meta: categoryafpfrk6ScVMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/category.vue")
  },
  {
    name: "تلویزیون خانه",
    path: "/tv",
    meta: indexbmkTbbXLeqMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/index.vue")
  },
  {
    name: "انیمیشن تلویزیون",
    path: "/tv/items/:id()",
    meta: _91id_93BP8LgDb1MOMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/items/[id].vue")
  },
  {
    name: "ورود تلویزیون",
    path: "/tv/login",
    meta: logingPcMR02I7hMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/login.vue")
  },
  {
    name: "tv-playlists-id",
    path: "/tv/playlists/:id()",
    meta: _91id_93oI1Lksmbv3Meta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/playlists/[id].vue")
  },
  {
    name: "tv-playlists",
    path: "/tv/playlists",
    meta: index8NLfeI7UPzMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/playlists/index.vue")
  },
  {
    name: "جستجو تلویزیون",
    path: "/tv/search",
    meta: searchAmb6vfmY1zMeta || {},
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/tv/search.vue")
  },
  {
    name: "verify",
    path: "/verify",
    component: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/pages/verify.vue")
  }
]